import type { SearchRow } from '@/features/header/types/searchResults';
import { cn } from '@/utils/cn';
import { Link } from 'react-router';

interface SearchResultRowProps {
  row: SearchRow;
  onSelect: () => void;
}

export const SearchResultRow = ({ row, onSelect }: SearchResultRowProps) => {
  const to = row.kind === 'nav' ? row.to : row.navigationTarget;

  return (
    <li>
      <Link
        to={to}
        onClick={onSelect}
        className={cn('flex cursor-pointer items-center justify-between text-sm transition-colors')}
      >
        <div className="mx-1 flex w-full items-center overflow-hidden rounded-sm px-4 py-1.5 hover:bg-neutral-100">
          {row.kind === 'nav' ? (
            <>
              <div className="flex max-w-34 min-w-34 items-center gap-2 overflow-hidden font-bold">
                <span className="flex items-center justify-center">{row.icon}</span>
                <span className="truncate" title={row.category}>
                  {row.category}
                </span>
              </div>
              <div className="mx-3 h-3.5 w-px bg-neutral-300" />
              <span className="truncate" title={row.label}>
                {row.label}
              </span>
            </>
          ) : (
            <div className="flex min-w-0 flex-col">
              <span className="truncate font-medium" title={row.label}>
                {row.label}
              </span>
              {row.breadcrumb && (
                <span className="truncate text-xs text-neutral-500" title={row.breadcrumb}>
                  {row.breadcrumb}
                </span>
              )}
            </div>
          )}
        </div>
      </Link>
    </li>
  );
};
